// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__gSh1G","savePackageButton":"ClientWallet_savePackageButton__3f9GL"};